const runtimeHostname =
  typeof window !== 'undefined' ? window.location.hostname : '';

export const isDemoHost =
  runtimeHostname.includes('tattoo-shop-assistant-demo') ||
  runtimeHostname.includes('demo.tattoostudioassistant');

export const isDemoMode =
  process.env.REACT_APP_DEMO_MODE === 'true' || isDemoHost;

export const demoModeLabel =
  process.env.REACT_APP_DEMO_MODE_LABEL || 'Demo Mode · Sample data only';
